import { StyleSheet, Font } from '@react-pdf/renderer';

import getTheme from '@/_shared/themes';
import themeComponents from '@/_shared/themes/theme.json';

const theme = getTheme();
export const sans = themeComponents.fontFamily.sans.join(',').replace('Ibm Plex Sans Var', "'IBM Plex Sans'");
export const serif = themeComponents.fontFamily.serif.join(',').replace('Bitter Variablefont Wght', 'Bitter');

Font.register({
  family: sans,
  fonts: [
    // { src: '/fonts/bitter-v26-latin-100', fontWeight: 100 },
    { src: '/fonts/zYXgKVElMYYaJe8bpLHnCwDKtdbUFI5NadY.ttf', fontWeight: 400 },
    { src: '/fonts/zYX9KVElMYYaJe8bpLHnCwDKjSL9MIZmdd_qFmo.ttf', fontWeight: 500 },
    { src: '/fonts/zYX9KVElMYYaJe8bpLHnCwDKjWr7MIZmdd_qFmo.ttf', fontWeight: 700 },
  ],
});

Font.register({
  family: serif,
  fonts: [
    { src: '/fonts/Bitter-Regular.ttf', fontWeight: 400 },
    { src: '/fonts/Bitter-Medium.ttf', fontWeight: 500 },
    { src: '/fonts/Bitter-SemiBold.ttf', fontWeight: 600 },
    { src: '/fonts/Bitter-Bold.ttf', fontWeight: 700 },
  ],
});

export const basePdfStyles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    paddingVertical: 65,
    paddingHorizontal: 55,
    fontFamily: sans,
    fontWeight: 400,
    maxWidth: '100%',
  },
  secondaryColor: {
    color: theme.palette.text.secondary,
  },
  primaryColor: {
    color: theme.palette.text.primary,
  },
  orangeColor: {
    color: '#FF4500',
  },
  darkPurpleColor: {
    color: 'rgb(33,11,71)',
  },
  sans: {
    fontFamily: sans,
  },
  serif: {
    fontFamily: serif,
  },

  italic: {
    fontStyle: 'italic',
  },
  thinFont: {
    fontWeight: 100,
  },
  regularFont: {
    fontWeight: 400,
  },
  mediumFont: {
    fontWeight: 500,
  },
  semiBoldFont: {
    fontWeight: 600,
  },
  boldFont: {
    fontWeight: 700,
  },
  _mt1: {
    marginTop: -4,
  },
  mb1: {
    marginBottom: 4,
  },
  mb2: {
    marginBottom: 8,
  },
  mt2: {
    marginTop: 8,
  },
  mt4: {
    marginTop: 16,
  },
  mb3: {
    marginBottom: 12,
  },
  mb4: {
    marginBottom: 16,
  },
  mb6: {
    marginBottom: 24,
  },
  pl3: {
    paddingLeft: 12,
  },
  pr3: {
    paddingRight: 12,
  },
  pl5: {
    paddingLeft: 20,
  },
  px3: {
    paddingLeft: 12,
    paddingRight: 12,
  },
  pb1: {
    paddingBottom: 2,
  },
  borderBottom: {
    borderBottom: `1 solid ${theme.palette.divider}`,
  },

  textCenter: {
    textAlign: 'center',
  },

  textLeft: { textAlign: 'left' },
  textRight: { textAlign: 'right' },

  grow: {
    flexGrow: 1,
  },
  noGrow: {
    flexGrow: 0,
  },
  shrink: {
    flexShrink: 1,
  },
  noShrink: {
    flexShrink: 0,
  },
  justifySpaceBetween: { justifyContent: 'space-between' },
  justifySpaceEnd: { justifyContent: 'flex-end' },

  bodyWrapper: {
    flexDirection: 'column',
    flexGrow: 1,
  },

  rowView: {
    display: 'flex',
    flexDirection: 'row',
  },

  columnView: {
    display: 'flex',
    flexDirection: 'column',
  },
  alignItemsCenter: {
    alignItems: 'center',
  },
  logoWrapper: {
    flexGrow: 0,
    width: 415,
    marginRight: 15,
    alignSelf: 'flex-end',
  },

  logo: {
    width: 312,
  },

  borderRight: {
    borderRight: `1 solid ${theme.palette.divider}`,
  },

  cellText: {
    fontSize: 7,
    lineHeight: 1.285,
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 4,
    paddingRight: 4,
  },

  w11: {
    width: 44,
  },
  w15: {
    width: 60,
  },
  w20: {
    width: 80,
  },
  w23: {
    width: 92,
  },
  w344: {
    width: 344,
  },

  mw100: {
    maxWidth: '100%',
  },
  smallFont: {
    fontSize: 9,
  },
  baseFont: {
    fontSize: 11,
  },
  xlFont: {
    fontSize: 12,
  },
  xxlFont: {
    fontSize: 16,
  },
  xxxlFont: {
    fontSize: 24,
  },
  noUnderline: {
    textDecoration: 'none',
  },
  capitalize: {
    textTransform: 'capitalize',
  },
  relative: {
    position: 'relative',
  },
});

export type PdfStylesType = typeof basePdfStyles;
